import '../plugins/slickPlugin';

export default function initM70() {
  $(function () {
    if ($('.module-m70').length > 0) {
      $('.module-m70').each(function () {
        $(this).find('.module-m70-testimonials').slick({
          infinite: true,
          slidesToScroll: 1,
          slidesToShow: 1,
          dots: false,
          arrows: true,
          appendArrows: $(this).find('.module-m70-testimonials-controls'),
        });
      });
    }
  });
}
